<template>
    <h2 class="text-warning round-text">Round {{ $store.getters.roundCounter }}</h2>
</template>

<script></script>

<style scoped>
h2 {
    font-family: 'Poppins', sans-serif;
    font-weight: 300;
}
</style>
